import React from 'react';
import { InputCountProps } from './types';
import { Typography } from '../typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { ButtonWrapper, Wrapper } from './input-count.styles';
import { AllAdd, AllReduce } from '@vtbhome/juicyfront/indexIcon';

export const InputCount: React.FC<InputCountProps> = ({ value, min, max, disabled, withoutControls, onChange }) => {
    const disabledByMin = typeof min === 'number' && value <= min;
    const disabledByMax = typeof max === 'number' && value >= max;
    const disabledAdd = disabled || disabledByMax;
    const disabledReduce = disabled || disabledByMin;

    const handleAdd = () => {
        if (max !== undefined) {
            return onChange(Math.min(max, value + 1));
        }
        onChange(value + 1);
    };

    const handleReduce = () => {
        if (min !== undefined) {
            return onChange(Math.max(min, value - 1));
        }
        onChange(value - 1);
    };

    return (
        <Wrapper>
            {!withoutControls && (
                <ButtonWrapper disabled={disabledReduce}>
                    <Button
                        disabled={disabledReduce}
                        round
                        size='s'
                        startAdornment={<AllReduce />}
                        onClick={handleReduce}
                    />
                </ButtonWrapper>
            )}
            <Typography size='h6' color={disabled ? 'neutral_50' : 'neutral_90'}>
                {value}
            </Typography>
            {!withoutControls && (
                <ButtonWrapper disabled={disabledAdd}>
                    <Button disabled={disabledAdd} round size='s' startAdornment={<AllAdd />} onClick={handleAdd} />
                </ButtonWrapper>
            )}
        </Wrapper>
    );
};
